<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

    <PageTitle title="Clipart" />
    <div class="card">
      <div class="card-content">
        <div class="columns is-centered">
          <div class="column is-5 has-text-centered">
            <b-field>
              <b-upload v-model="clipart.file" drag-drop expanded accept="image/*">
                <section class="section">
                  <div class="content has-text-centered">
                    <p><b-icon icon="upload" size="is-large"></b-icon></p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section>
              </b-upload>
            </b-field>

            <p class="mb-2"><span v-if="clipart.file" class="tag is-primary">{{clipart.file.name}}</span></p>

            <b-button @click="proceed()" type="is-primary">Save</b-button>

          </div>
        </div>

        <!-- Pagination Controls -->
        <div class="columns" v-if="fetchCliparts.length > 0">
          <div class="column is-9">
            <b-pagination
              :total="fetchCliparts.length"
              v-model="current_clipart_page"
              :per-page="clipart_page_items"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
            </b-pagination>
          </div>
          <div class="column is-3">
            <b-numberinput
              v-model="current_clipart_page"
              :controls="false"
              placeholder="Page number"
            ></b-numberinput>
          </div>
        </div>

        <!-- Clipart Grid with Pagination -->
        <div class="columns is-multiline">
          <div v-for="clipart in currentPageCliparts" :key="clipart._id" style="position: relative;" class="column is-2">
            <span class="hover-allow" style="position: absolute;right: 0;z-index: 9" @click="deletethisClipart(clipart._id)"><b-icon icon="delete"></b-icon></span>
            <show-image :src="clipart.file"></show-image>
          </div>
        </div>

        <!-- Show message when no cliparts on current page -->
        <div v-if="currentPageCliparts.length === 0 && fetchCliparts.length > 0" class="has-text-centered">
          <p class="title is-5">No cliparts found on this page</p>
          <p class="subtitle is-6">Try navigating to a different page</p>
        </div>

        <!-- Show message when no cliparts exist -->
        <div v-if="fetchCliparts.length === 0 && !isLoading" class="has-text-centered">
          <p class="title is-5">No cliparts available</p>
          <p class="subtitle is-6">Upload your first clipart to get started</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import ShowImage from '@/components/General/ShowImage'
export default {
  name : 'Clipart',
  components : {
    PageTitle,
    ShowImage
  },
  data(){
    return {
      isLoading : false,
      modalGradeActive : false,
      clipart : {
        file : null
      },
      // Pagination data similar to SetQuestion.vue
      current_clipart_page: 1,
      clipart_page_items: 50
    }
  },
  computed : {
    ...mapGetters(['fetchCliparts', 'getTeacherToken']),
    // Computed property for current page cliparts similar to SetQuestion.vue
    currentPageCliparts() {
      return this.fetchCliparts.slice(
        (this.current_clipart_page - 1) * this.clipart_page_items,
        this.current_clipart_page * this.clipart_page_items
      );
    }
  },
  methods : {
    ...mapActions(['loadCliparts', 'createClipart', 'deleteClipart']),
    proceed(){
      if(!this.clipart.file){
        return this.$buefy.toast.open({
          message: 'Please add an image before proceeding',
          type: 'is-danger'
        })
      }
      this.isLoading = true
      this.createClipart({
        token : this.getTeacherToken,
        clipart : this.clipart
      }).then(() => {
        this.isLoading = false
        this.clipart.file = null
        this.$buefy.toast.open({
          message: 'Clipart created successfully',
          type: 'is-success'
        })
      }).catch(err => {
        this.isLoading = false
        this.clipart.file = null
        console.log(err)
        this.$buefy.toast.open({
          message: err.response.data,
          type: 'is-danger'
        })
      })
    },
    deletethisClipart(id){
      this.$buefy.dialog.confirm({
        title: 'Continue deleting this clipart',
        message : 'Are you sure want to delete this clipart permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteClipart({
            token : this.getTeacherToken,
            id
          }).then(() => {
            this.$buefy.toast.open({
              message: 'Clipart deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    }
  },
  async created(){
    this.isLoading = true
    try{
      await this.loadCliparts({ token : this.getTeacherToken })
    }catch(err){
      this.$buefy.toast.open({
        message: err.response.data,
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
  
}
</script>